module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-v2-custom",
    class: [_vm.themeClass(), {
      'table-v2-custom--responsive': _vm.responsive
    }]
  }, [_c('div', {
    staticClass: "table-v2-inner-spacing"
  }, [_c(_vm.tableComponent, {
    ref: "table",
    tag: "component",
    attrs: {
      "externalFiltering": _vm.externalFiltering,
      "data": _vm.data,
      "default-sort": _vm.sort,
      "hoverOverlayComponent": _vm.hoverOverlayComponent,
      "bottomOverlayComponent": _vm.bottomOverlayComponent,
      "sort": _vm.sort,
      "overlayColumnStart": _vm.overlayColumnStart,
      "rowKey": _vm.rowKey,
      "refreshTable": _vm.refreshTable
    },
    on: {
      "sort-change": _vm.clickHandler
    }
  }, [_c('template', {
    slot: "empty"
  }, [_vm._t("empty")], 2), _vm._v(" "), _c('template', {
    slot: "loading"
  }, [_vm._t("loading")], 2), _vm._v(" "), _c('template', {
    slot: "tableHeader"
  }, [_vm._t("tableHeader")], 2), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _vm._t("bottom")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12286644"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/tables/components/StyledTable.vue
// module id = 2399
// module chunks = 0